// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"476":"0a38f082","787":"3315d5f1"}[chunkId] + ".chunk.js";
};